var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8749 17.1875H49.5265C49.8876 17.1853 50.241 17.2867 50.5402 17.4784C50.8394 17.6701 51.0705 17.9432 51.2031 18.2618L54.3749 25.7813",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62494 30.9375H39.8749",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5937 46.4062C45.5967 46.4062 48.0312 44.0977 48.0312 41.25C48.0312 38.4023 45.5967 36.0938 42.5937 36.0938C39.5906 36.0938 37.1562 38.4023 37.1562 41.25C37.1562 44.0977 39.5906 46.4062 42.5937 46.4062Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 46.4062C18.4092 46.4062 20.8437 44.0977 20.8437 41.25C20.8437 38.4023 18.4092 36.0938 15.4062 36.0938C12.4031 36.0938 9.96869 38.4023 9.96869 41.25C9.96869 44.0977 12.4031 46.4062 15.4062 46.4062Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1562 41.25H20.8437",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96869 41.25H5.43744C4.95673 41.25 4.49572 41.0689 4.15581 40.7466C3.8159 40.4243 3.62494 39.9871 3.62494 39.5312V15.4688C3.62494 15.0129 3.8159 14.5757 4.15581 14.2534C4.49572 13.9311 4.95673 13.75 5.43744 13.75H39.8749V36.7812",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8749 25.7812H54.3749V39.5312C54.3749 39.9871 54.184 40.4243 53.8441 40.7466C53.5042 41.0689 53.0431 41.25 52.5624 41.25H48.0312",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.c40691d615a1aced0af155a9bd36b62a.svg";
export { ForwardRef as ReactComponent };